import {computed} from "vue";

const useEmbed = () => {
    const isEmbedded = computed(() => window.location.href.includes('embed') || window.location.href.includes('shopify'));

    return {
        isEmbedded,
    };
};

export default useEmbed;